<sfx-toolbar enableDivider>
    <span translate>Email, calendar & other accounts</span>
</sfx-toolbar>
<sfx-content>
    <sfx-email-settings></sfx-email-settings>
    <sfx-calendar-settings></sfx-calendar-settings>
    <sfx-meeting-tool-settings></sfx-meeting-tool-settings>
</sfx-content>
